import { styled } from '@mui/material'
import { FC, FormEvent, ReactNode, useCallback } from 'react'

const SubmitTrigger = styled('button')`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`

const BlurForm: FC<BlurFormProps> = (props: BlurFormProps) => {
  // Blur on submit
  const onSubmit = useCallback((event: FormEvent) => {
    event.preventDefault()

    // Blur the active element (text fields) to apply changes to filter
    const focusedElement = event.currentTarget.ownerDocument.activeElement

    if (focusedElement instanceof HTMLElement) {
      focusedElement.blur()
    }
  }, [])

  return (
    <form className={props.className} onSubmit={onSubmit}>
      {props.children}
      <SubmitTrigger
        aria-label='submit trigger button'
        tabIndex={-1}
        type='submit'
      />
    </form>
  )
}

type BlurFormProps = {
  className?: string
  children?: ReactNode
}

export default BlurForm
